import angular from 'angular';

angular
  .module('cxSettings')
  .controller('InsertGroupPlaceholderDialogCtrl', [
    'close',
    'groupPlaceholders',
    insertGroupPlaceholderDialogCtrl,
  ]);

function insertGroupPlaceholderDialogCtrl(close, groupPlaceholders) {
  var vm = this;
  var GROUPS_WITHOUT_TABLE_OUTPUT = ['invoices', 'transactions'];
  vm.groups = groupPlaceholders || [];
  vm.selectedGroup = null;
  vm.availablePlaceholders = [];
  vm.selectedPlaceholdersModel = [];
  vm.outputMode = 'group';
  vm.includeHeaderRow = false;

  vm.isTableOutputAllowed = function() {
    if (!vm.selectedGroup) return true;
    return GROUPS_WITHOUT_TABLE_OUTPUT.indexOf(vm.selectedGroup.groupName) === -1;
  };

  vm.selectGroup = function(group) {
    vm.availablePlaceholders = group ? (group.placeholders || []).slice() : [];
    vm.selectedPlaceholdersModel = [];
    if (
      vm.outputMode === 'table' &&
      group &&
      GROUPS_WITHOUT_TABLE_OUTPUT.indexOf(group.groupName) !== -1
    ) {
      vm.outputMode = 'group';
    }
  };

  vm.filterPlaceholders = function(query) {
    var q = query ? query.toLowerCase() : '';
    var selected = vm.selectedPlaceholdersModel.map(function(p) {
      return p.placeholder;
    });
    return vm.availablePlaceholders.filter(function(p) {
      return (
        selected.indexOf(p.placeholder) === -1 &&
        (!q ||
          p.label.toLowerCase().indexOf(q) !== -1 ||
          p.placeholder.toLowerCase().indexOf(q) !== -1)
      );
    });
  };

  var selectedPlaceholderNames = function() {
    return vm.selectedPlaceholdersModel.map(function(p) {
      return p.placeholder;
    });
  };

  vm.isValid = function() {
    return !!vm.selectedGroup && vm.selectedPlaceholdersModel.length > 0;
  };

  vm.save = function() {
    if (!vm.isValid()) return;
    var group = vm.selectedGroup.groupName;
    var tags = selectedPlaceholderNames();
    var html = '';

    if (vm.outputMode === 'tags') {
      html = tags.join(' ');
    } else if (vm.outputMode === 'group') {
      html = `{${group}} ${tags.join(' ')} {/${group}}`;
    } else if (vm.outputMode === 'table') {
      var cells = tags
        .map(function(tag, idx) {
          var content = tag;
          if (idx === 0) content = `{${group}} ${content}`;
          if (idx === tags.length - 1) content = `${content} {/${group}}`;
          return `<td>${content}</td>`;
        })
        .join('');
      var header = '';
      if (vm.includeHeaderRow) {
        var th = tags
          .map(function() {
            return '<th></th>';
          })
          .join('');
        header = `<thead><tr>${th}</tr></thead>`;
      }
      html = `<table border="1" cellpadding="1" cellspacing="1">${header}<tbody><tr>${cells}</tr></tbody></table>`;
    }
    close(html, 500);
  };

  vm.cancel = function() {
    close(null, 500);
  };
}
